import { Pipe, PipeTransform } from '@angular/core';
import { IBookingSearchResultColumnStructure, IBookingSearchResultConfig } from "../../interfaces/IConfigurableTable";

@Pipe({
    name: 'isRowContainsColumn'
})

export class IsRowContainsColumnPipe implements PipeTransform {
    public transform(rowIndex: number, columnKey: string, config: IBookingSearchResultConfig): boolean {
        return config.rowArray[rowIndex].columnStructureArray.some((test: IBookingSearchResultColumnStructure): boolean => test.key === columnKey);
    }
}
